export default function Privacy() {
  return (
    <section className="max-w-4xl mx-auto px-6 py-16">
      <h2 className="text-4xl font-bold text-blue-600 mb-6 text-center">
        📜 Popalooza Privacy Policy
      </h2>

      <div className="bg-white rounded-lg shadow-md p-6 space-y-6 text-gray-700 leading-relaxed">
        <p><strong>Effective Date:</strong> December 2025</p>
        <p><strong>Version:</strong> 1.0.0</p>

        <p>
          Popalooza (“the Game”) values your privacy. This Privacy Policy explains how we collect,
          use, and protect your information when you play our game.
        </p>

        <h3 className="text-2xl font-semibold text-blue-600">🔎 Information We Collect</h3>
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Gameplay Data:</strong> Scores, levels completed, and progression details to track achievements and unlock features.</li>
          <li><strong>Device Information:</strong> Basic technical details (device type, operating system, app version) to improve performance and fix bugs.</li>
          <li><strong>Subscription Data:</strong> If you purchase a monthly subscription, we collect transaction details (through app store providers) to manage your ad‑free experience.</li>
          <li><strong>Advertising & Analytics:</strong> Anonymous usage data to measure engagement, show ads (if not subscribed), and improve gameplay.</li>
        </ul>

        <h3 className="text-2xl font-semibold text-blue-600">🎯 How We Use Your Information</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>To provide core gameplay features and save your progress.</li>
          <li>To display ads unless you subscribe for ad‑free play.</li>
          <li>To process subscriptions and maintain premium features.</li>
          <li>To analyze performance and improve the game experience.</li>
        </ul>

        <h3 className="text-2xl font-semibold text-blue-600">🔐 Data Sharing</h3>
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Third‑Party Services:</strong> Ads and subscriptions are handled by trusted providers (e.g., Google Play, Apple App Store, RevenueCat, Firebase Analytics).</li>
          <li><strong>No Sale of Personal Data:</strong> We do not sell your personal information to third parties.</li>
          <li><strong>Legal Requirements:</strong> We may disclose information if required by law or to protect our rights.</li>
        </ul>

        <h3 className="text-2xl font-semibold text-blue-600">🛡️ Security</h3>
        <p>
          We use industry‑standard safeguards to protect your data. However, no system is completely secure,
          and we cannot guarantee absolute protection.
        </p>

        <h3 className="text-2xl font-semibold text-blue-600">👶 Children’s Privacy</h3>
        <p>
          Popalooza is designed for general audiences. We do not knowingly collect personal information
          from children under 13. If you believe a child has provided data, please contact us to remove it.
        </p>

        <h3 className="text-2xl font-semibold text-blue-600">⚖️ Your Rights</h3>
        <p>
          Depending on your location, you may have rights to access, correct, or delete your data.
          Please refer to your app store’s privacy controls or contact us directly.
        </p>

        <h3 className="text-2xl font-semibold text-blue-600">📩 Contact Us</h3>
        <p>
          If you have questions about this Privacy Policy, please reach out to our support team at:{" "}
          <a href="mailto:info@popalooza.com.au" className="text-blue-600 font-semibold hover:underline">
            info@popalooza.com.au
          </a>
        </p>

        <p className="italic text-gray-600">
          ✨ This policy may be updated from time to time. We encourage you to review it regularly to stay informed.
        </p>
      </div>
    </section>
  );
}
